import { HtmlHTMLAttributes, memo } from "react";
import classNames from "classnames";

import styles from "./style.module.scss";

type CreditCardPreviewProps = {
  cardBrand?: string | null
  cardLast4?: string | null
  cardHolderName?: string | null
} & HtmlHTMLAttributes<HTMLDivElement>

export const CreditCardPreview = memo<CreditCardPreviewProps>(({ cardBrand, cardLast4, cardHolderName, className, ...rest }) => {

  const isEmptyCard = cardLast4 === "mpty";

  return (
    <div {...rest} className={classNames(styles.root, className)}>
      <span className={classNames(styles.logo, cardBrand ? styles[cardBrand] : "")} />
      <span className={styles.dots}>{isEmptyCard ? "empty" : "••••"}</span>
      <span className={styles.last}>{isEmptyCard ? "" : cardLast4}</span>
      {cardHolderName &&
        <span className={styles.cardHolder}>{cardHolderName}</span>
      }
    </div>
  );
});

export default CreditCardPreview;
